<template>
  <div class="card" v-show="currentCardId == 'job-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>職歴を入力</h2>
        <p v-if="subtitle">{{ subtitle }}</p>
      </div>
      <div class="card-content-list">
        <div class="edit-form-list">
          <div class="add-item">
            <div class="button-reset">
              <el-button
                v-if="
                  formatData.jobDetailHistories &&
                  formatData.jobDetailHistories.length > 1
                "
                @click="jobResetVisible = true"
                >リセット</el-button
              >
            </div>
            <NewRirekishoResetDialog
              :value="jobResetVisible"
              name="job-reset"
              title="職歴リセット"
              message="入力されている職歴をすべて削除します。よろしいですか？"
              actions-class="text-left"
              @input="jobResetVisible = $event"
              @confirm="resetJobHistories"
            />
          </div>
          <transition-group name="fade" tag="div">
            <HistoryItemJob
              v-for="(item, index) in formatData.jobDetailHistories"
              :key="item.uuid"
              :item="item"
              :length="
                (formatData.jobDetailHistories &&
                  formatData.jobDetailHistories.length) ||
                0
              "
              :index="index"
              :id="item.uuid"
              :class="{ active: activeHistoryItem == item.uuid }"
              :minYear="basicData.birthYear"
              :createDate="formatData.createDate"
              :activeHistoryItem="activeHistoryItem"
              :descriptionPlaceholder="'会社名を入力'"
              :descriptionMaxLength="descriptionMaxLength"
              @click.native="activateHistoryItem(item.uuid)"
              @add-history-item="addJobHistory"
              @delete-history-item="deleteJobHistory"
              @move-history-item="moveJobHistory"
              @add-project-history-item="addProjectHistory"
              @delete-history-item-detail="deleteHistoryDetail"
              @move-history-item-detail="moveJobHistoryDetail"
            />
          </transition-group>
          <div class="add-list-item">
            <el-button
              icon="el-icon-plus"
              circle
              type="success"
              @click="addJobHistory()"
            />
          </div>
          <div
            class="attention-limit column"
            v-if="previewErrors.eduJobHistory"
          >
            <i class="el-icon-warning"></i>&ensp;{{
              previewErrors.eduJobHistory
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import HistoryItemJob from '@/components/formats/RirekishoParts/HistoryItemJob.vue'
import NewRirekishoResetDialog from '@/components/format-edit/new-rirekisho/NewRirekishoResetDialog.vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { useDesignRirekishoJobDetail } from '@/composables/format-edit/useDesignRirekishoJobDetail'
import type { BasicData } from '@/utils/format-edit/basicData'

defineProps<{
  currentCardId?: string
  basicData: BasicData
  previewErrors: Record<string, string>
  subtitle?: string
}>()

const descriptionMaxLength = 80
const formatData = useRirekishoFormatData()
const jobResetVisible = ref(false)
const {
  activeHistoryItem,
  addJobHistory,
  deleteJobHistory,
  moveJobHistory,
  resetJobHistories,
  addProjectHistory,
  deleteHistoryDetail,
  moveJobHistoryDetail,
  activateHistoryItem
} = useDesignRirekishoJobDetail(formatData)
</script>
